import { Injectable } from '@angular/core';
import { ApiProvider } from '../api/api';
import { ConfigDataProvider } from '../config-data/config-data';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ApiGetProvider {


	private mobileKey = "";

	constructor(
		private apiProvider: ApiProvider,
		private configDataProvider: ConfigDataProvider
	) {

	}

	public getMessages(connectionType) {

		this.mobileKey = this.configDataProvider.getMobileKey();
		let endpoint = "getMessages/" + this.mobileKey + "/" + connectionType;
		return this.apiProvider.get(endpoint);

	}

	public getPermissions() {

		this.mobileKey = this.configDataProvider.getMobileKey();
		let endpoint = "getPermissions/" + this.mobileKey;
		return this.apiProvider.get(endpoint);

	}

	public getAdvalvasItems() {

		this.mobileKey = this.configDataProvider.getMobileKey();
		let endpoint = "getAdvalvasItems/" + this.mobileKey;
		return this.apiProvider.get(endpoint);

	}

	public getWerkbontypes() {

		this.mobileKey = this.configDataProvider.getMobileKey();
		let endpoint = "getWerkbontypes/" + this.mobileKey;
		return this.apiProvider.get(endpoint);

	}

	public getAfdelingen() {

		this.mobileKey = this.configDataProvider.getMobileKey();
		let endpoint = "getAfdelingen/" + this.mobileKey;
		return this.apiProvider.get(endpoint);

	}

	public getCategories() {

		this.mobileKey = this.configDataProvider.getMobileKey();
		let endpoint = "getCategories/" + this.mobileKey;
		return this.apiProvider.get(endpoint);

	}

	public getMessageTemplates() {

		this.mobileKey = this.configDataProvider.getMobileKey();
		let endpoint = "getMessageTemplates/" + this.mobileKey;
		return this.apiProvider.get(endpoint);

	}

	public getRooms() {

		this.mobileKey = this.configDataProvider.getMobileKey();
		let endpoint = "getRooms/" + this.mobileKey;
		return this.apiProvider.get(endpoint);

	}

	public getCalendarObjects() {

		let end = new Date();
		end.setDate(end.getDate() + 30);
		let endDate = end.toISOString().split('T')[0];

		let start = new Date();
		start.setDate(start.getDate() - 30);
		let startDate = start.toISOString().split('T')[0];

		this.mobileKey = this.configDataProvider.getMobileKey();
		let endpoint = "getCalendarObjects/" + this.mobileKey + "/" + startDate + "/" + endDate;
		return this.apiProvider.get(endpoint);

	}

	public getUsers() {

		this.mobileKey = this.configDataProvider.getMobileKey();
		let endpoint = "getUsers/" + this.mobileKey;
		return this.apiProvider.get(endpoint);

	}

	public getAllMyUsers() {

		this.mobileKey = this.configDataProvider.getMobileKey();
		let endpoint = "getAllMyUsers/" + this.mobileKey;
		return this.apiProvider.get(endpoint);

	}


	public updateKey() {

		this.mobileKey = this.configDataProvider.getMobileKey();
		let user = this.configDataProvider.getUserData();
		let userId = user && user.id ? user.id : "";

		let endpoint = "update_key/"+userId+"/"+this.mobileKey;
		let observable : Observable<any> = this.apiProvider.get(endpoint);
		
		observable = observable.pipe(map((data)=>{

			if(data && data.status == "success") {
				this.configDataProvider.setMobileKey(data.mobilekey);
				user.mobile_key = data.mobilekey;

				this.configDataProvider.setUserData(user);
			}

			return data;
		}));

		return observable;
	}


}



// WEBPACK FOOTER //
// ./src/providers/api-get/api-get.ts